import React from 'react'
import Card from './Card';
import bannerImage from './assets/Wallpaper.jpg'
import "./Home.css"
import bannerImage2 from './assets/Advanced_Test_Reactor.jpg'
import bannerImage3 from "./assets/1024px-Agency_headquarters_Graphic.jpg"

const Home = () => {
  const posts = [
  { image: bannerImage , title: "The Cost of Nuclear Energy", description: "An overview on the challenges of nuclear energy.", link: "/post" },
  { image: bannerImage2 ,title: "Types of Reactors", description: "A look at the different types of nuclear reactors.", link: "/ReactorTypes" },
  { image: bannerImage3 ,title: "Killing Nuclear Power", description: "How I would go about ruining the nuclear industry (not advice).", link: "/RuiningNuclear" },
];


  return (
    <main>
        <h1 className="name">MILO PETERSON's</h1>
        <h3 className="subtitle">REFERENCE PAGE</h3>
        <h2 className="posttype">Nuclear Energy Posts:</h2>
        <ul className="postlist">
          {posts.map((post, idx) => (
        <Card key={idx} {...post} />
      ))}
        </ul>

    </main>
  )
}

export default Home